// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles-module--icon--3-aNq"};